module.exports = __webpack_public_path__ + "static/media/camera1.f73f35ce.png";